<template>
  <div>
    <anchor-tabs square-corners height="30" v-model="tab" :tabs="tabs">
      <template v-slot:extra-items>
        <v-spacer />
        <div class="tab-results-counter pb-4 pr-5 pt-1 black--text">
          Total: {{ payload.files.length }}
        </div>
      </template>
    </anchor-tabs>
    <v-divider />
    <anchor-data-table
      :loading="loading"
      :headers="headers"
      :items="currentItems"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <template v-slot:item.filename="{ item }">
        <anchor-simple-link :text="item.filename" @click="() => onFilenameClickHandler(item)" />
      </template>
      <template v-slot:item.docDate="{ item }">
        {{ item.docDate|date }}
      </template>
      <template v-slot:item.dateExpire="{ item }">
        {{ item.dateExpire|date }}
      </template>
      <template v-slot:item.createdOn="{ item }">
        {{ item.createdOn|datetime }}
      </template>
      <template v-slot:item.actions="{ item }">
        <slot name="actions-column" v-bind:file="item" />
      </template>
    </anchor-data-table>
  </div>
</template>

<script>
import AnchorTabs from '../Tabs';
import AnchorDataTable from '../wrappers/DataTable';
import AnchorSimpleLink from '../SimpleLink';

export default {
  name: 'AnchorFilesTable',
  components: {
    AnchorTabs,
    AnchorDataTable,
    AnchorSimpleLink,
  },
  props: {
    payload: Object,
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    actionsWidth: {
      type: Number,
      default: 100,
    },
  },
  data: () => ({
    tab: 0,
    approvedStatuses: [
      'complete',
      'approved',
    ],
    rejectedStatuses: [
      'rejected',
      'removed',
    ],
    pendingStatuses: [
      null,
      undefined,
      'review',
      'pending',
    ],
  }),
  computed: {
    items: vm => vm.payload.files.map(file => {
      const tmp = file;
      ['docDate', 'dateExpire', 'createdOn'].forEach(key => {
        if (file[key]) {
          tmp[key] = new Date(file[key]);
        }
      });
      return tmp;
    }),
    pending: vm => vm.items.filter(item => vm.pendingStatuses.includes(item.checklistStatus)),
    approved: vm => vm.items.filter(item => vm.approvedStatuses.includes(item.checklistStatus)),
    rejected: vm => vm.items.filter(item => vm.rejectedStatuses.includes(item.checklistStatus)),
    currentItems: vm => {
      const tabMap = {
        0: vm.pending,
        1: vm.approved,
        2: vm.rejected,
      };
      return tabMap[vm.tab];
    },
    tabs: vm => ([
      { text: 'Pending', count: vm.pending.length.toString() },
      { text: 'Approved', count: vm.approved.length.toString() },
      { text: 'Rejected', count: vm.rejected.length.toString() },
    ]),
    headers: vm => {
      const list = [
        { text: 'File Name', value: 'filename' },
        { text: 'Document Date', value: 'docDate' },
        { text: 'Expiration', value: 'dateExpire' },
        { text: 'Uploaded By', value: 'createdByUserName' },
        { text: 'Upload Date', value: 'createdOn' },
      ];

      if (vm.tab !== 0) {
        list.push({
          text: `${vm.tab === 1 ? 'Approved' : 'Rejected'} By`,
          value: 'checklistStatusUserName',
        });
        list.push({
          text: `${vm.tab === 1 ? 'Approval' : 'Rejection'} Notes`,
          value: 'checklistStatusNotes',
        });
      }

      list.push({
        text: 'Actions',
        value: 'actions',
        align: 'center',
        width: vm.actionsWidth,
        sortable: false,
      });

      return list;
    },
  },
  methods: {
    onFilenameClickHandler(item) {
      window.open(item.linkToFile, '_blank');
    },
  },
};
</script>
